<span
    role="button"
    class="inline-flex shrink-0 items-center justify-center text-[32px] text-black"
    (click)="toggleFavorite($event); $event.preventDefault(); $event.stopPropagation()"
    [attr.aria-label]="isFavorite() ? 'Aus Favoriten entfernen' : 'Als Favorit speichern'"
    tabindex="0"
    (keydown.enter)="toggleFavorite($event)"
>
    @if (isFavorite()) {
        <i class="icon-heart-filled" aria-hidden="true"></i>
    } @else {
        <i class="icon-heart" aria-hidden="true"></i>
    }
</span>
